import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Typography } from "@material-ui/core";
import './Agents.css';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
    fontSize: "34px",
    [theme.breakpoints.down("md")]: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      fontSize: "15px",
    },
    [theme.breakpoints.down("xl")]: {
      width: theme.spacing(6),
      height: theme.spacing(6),
      fontSize: "22px"
    },
  },
}));

export default function Agents(props) {
  const classes = useStyles();
  const dashboard = useSelector((state) => state.dashboard);
  const agentData = dashboard?.data?.agents || [];
  
 
 
 
  
  let agentList = [];
  for (const agent of agentData) {
    agentList.push(
      <div className="agent-detail" key={agent.id}>
        <div className="avatar">
          <Avatar className={classes.large}>{agent.first_name.charAt(0)}{agent.last_name.charAt(0)}</Avatar>
        </div>
        <div className="agent-text">
          <Typography variant="subtitle2" style={{color: "#5A5A5A", lineHeight: 1.3, paddingBottom: 0}}>
            {agent.first_name} {agent.last_name}
          </Typography>
          <Typography variant="subtitle1">Auctioneer</Typography>
          <Typography variant="subtitle1">{agent.mobile_no}</Typography>
          {/* Temporarily disabling agent email to prevent horizontal scrolls as per Jamie's request */}
          {/* <Typography variant="subtitle1">{agent.email}</Typography> */}
        </div>
      </div>
    );
  }
  
  return (
    <div className="agents-base">
      <Typography className={props.classes.body1} style={{paddingBottom: "12px"}}>Your Agents</Typography>
      <div className="agent-details">
        {agentList}
      </div>
    </div>
  );
}